module.exports = __webpack_public_path__ + "img/step3-b.3c94e8e9.png";